export const GIFTCARDSKU = '999999999';
